import React from "react";
import * as SelectPrimitive from "@radix-ui/react-select";
import { Check, ChevronDown } from "lucide-react";

// Rounded, brand-styled dropdown (replaces the OS-native select list).
export default function RoundSelect({ value, onChange, options, label, testId, isAR, className = "" }) {
  return (
    <SelectPrimitive.Root value={value} onValueChange={onChange} dir={isAR ? "rtl" : "ltr"}>
      <SelectPrimitive.Trigger aria-label={label} data-testid={testId}
        className={`h-11 inline-flex items-center justify-between gap-2 rounded-full border border-propertic-hairline-2 bg-white px-4 text-sm text-propertic-ink min-w-0 hover:border-propertic-gold focus:outline-none focus-visible:ring-2 focus-visible:ring-propertic-gold transition-colors ${className}`}>
        <span className="truncate"><SelectPrimitive.Value /></span>
        <SelectPrimitive.Icon><ChevronDown className="w-4 h-4 text-propertic-muted" /></SelectPrimitive.Icon>
      </SelectPrimitive.Trigger>
      <SelectPrimitive.Portal>
        <SelectPrimitive.Content position="popper" sideOffset={6}
          className="z-[80] max-h-[320px] min-w-[var(--radix-select-trigger-width)] overflow-hidden rounded-2xl border border-propertic-hairline-2 bg-white shadow-[0_18px_50px_rgba(10,37,64,0.16)]"
          data-testid={`${testId}-content`}>
          <SelectPrimitive.Viewport className="p-1.5 max-h-[320px] overflow-y-auto">
            {options.map((o) => (
              <SelectPrimitive.Item key={o.value} value={o.value}
                className="relative flex items-center gap-2 rounded-xl ps-3 pe-8 py-2 text-sm text-propertic-ink cursor-pointer select-none outline-none data-[highlighted]:bg-propertic-sand data-[state=checked]:font-semibold data-[state=checked]:text-propertic-navy"
                data-testid={`${testId}-option-${String(o.value || "all").toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                <SelectPrimitive.ItemText>{o.label}</SelectPrimitive.ItemText>
                <SelectPrimitive.ItemIndicator className="absolute end-2.5"><Check className="w-4 h-4 text-propertic-gold" /></SelectPrimitive.ItemIndicator>
              </SelectPrimitive.Item>
            ))}
          </SelectPrimitive.Viewport>
        </SelectPrimitive.Content>
      </SelectPrimitive.Portal>
    </SelectPrimitive.Root>
  );
}
